import axios from "axios";

const getfile = async (thumb, authToken, userId) => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/api/clm/file/${thumb}`;
  const headers = {
    Authorization: `Bearer ${authToken}`,
    "X-Client-Auth": process.env.REACT_APP_CLIENT_AUTH,
    "x-user-id": userId,
  };
  try {
    const response = await axios.get(apiUrl, {
      headers,
      responseType: "blob",
    });

    const imageUrl = URL.createObjectURL(response.data);
    return imageUrl;
  } catch (err) {
    console.error("Error fetching image:", err);
    return null;
  }
};

export default getfile;

// import axios from "axios";

// const getfile = async (thumb) => {
//   const apiUrl = `${process.env.REACT_APP_API_URL}/api/clm/file/${thumb}`;
//   const headers = {
//     Authorization: `Bearer ${process.env.REACT_APP_AUTH_TOKEN}`,
//     "X-Client-Auth": process.env.REACT_APP_CLIENT_AUTH,
//     "x-user-id": process.env.REACT_APP_USER_ID,
//   };

//   try {
//     const response = await axios.get(apiUrl, {
//       headers,
//       responseType: "blob",
//     });

//     const imageUrl = URL.createObjectURL(response.data); // สร้าง URL จากไฟล์ Blob
//     return imageUrl;
//   } catch (err) {
//     console.error("Error fetching image:", err);
//     return null; // ถ้าเกิดข้อผิดพลาดให้ return null
//   }
// };

// export default getfile;
